/**
* In Add Parent function is used to add or create new parent details and it's functions declare this file
**/
import {Link,useNavigate} from 'react-router-dom';
import {useState} from 'react';
import * as Yup from 'yup';
import { validate } from './../../../services/ValidationService';
import ApiService from './../../../services/ApiService';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ImageCroper from './../../../shared/modals/ImageCroper'
import { dataURItoBlob,filterGeoLocation,goBack } from './../../../services/UtilsService';
import { toast } from 'react-toastify';
import Autocomplete from 'react-google-autocomplete';
import NavigationModal from './../../../shared/modals/NavigationModal';
import { useTranslation } from 'react-i18next';

function AddParent(){
	//Intial state declaration
	const [data,setData]=useState({});	
	const [error,setError]=useState({});	
	const [valid,setValid]=useState(true);	
	const navigate = useNavigate();
	const [show,SetShow]=useState(false);
	const [image, setImage] = useState('');
	const [cropImge, setCropImage] = useState();
	const [showModal, setShowModal] = useState(false);  // State for navigation modal visibility
	const [dynamicId, setDynamicId] = useState(null);  // State for navigation id
	const [modalMessage, setModalMessage] = useState('');  // State for navigation modal message
	const { t } = useTranslation();
	
	//callback function
	//const handleClose = () => SetShow(false);
	const handleClose = () => {
		SetShow(false);
		// Reset the file input value
		const fileInput = document.getElementById('file-5');
		if (fileInput) {
		  fileInput.value = ""; // Clear the file input so the same file can be selected again
		}
	  };
	  
	const imageData= (data)=> setCropImage(data)
	
	//validate patterns
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	
    /** 
	* Validation schema for Parent Fields
	* @first_name - required field and pass the parent first_name
	* @last_name - required field and pass the parent last_name
	* @members - required field and pass the parent members
	* @email - required field and should be in correct parent email format 
	* @mobileNumber - required field and pass the parent mobileNumber
	* @city - required field and pass the parent city 
	* @state - required field and pass the parent state 
	* @gender - required field and pass the parent gender 
	* @zipcode - required field and pass the parent zipcode 
	**/
    const fields = [
		{ name: 'first_name', validation: Yup.string().trim().required(t('error.required')) },
		{ name: 'last_name', validation: Yup.string().trim().required(t('error.required')) },
		{ 
		name: 'members', 
		validation: Yup.string()
			.matches(/^\d+$/, t('error.numberFormat'))
			.required(t('error.required')) 
		},
		{ 
		name: 'email', 
		validation: Yup.string()
			.email(t('error.email')) // built-in email validation
			.required(t('error.emailRequired')) 
		},
		{ name: 'mobileNumber', validation: Yup.string() },
		{ name: 'city', validation: Yup.string()},
		{ name: 'gender', validation: Yup.string()},
		{ name: 'state', validation: Yup.string() },
		{
			name: 'zipcode',
			validation: Yup.string()
			  .nullable() // Allows the field to be nullable
			  .matches(/^[a-zA-Z0-9]+$/,t('error.zipcodeAlpha')) // Allows empty or valid number format
			//   .test('len', constantVariables.error.zipcode, function (value) {
			// 	return !value || value.length >= 5; // Only check length if value is not empty
			//   })
		  },
    ];
   
   /** 
   * To handle input change event 
   * @e - we get the event details from the Change action
   **/
	 const handleChange=async(e)=>{
		 e.preventDefault();
		 const {name ,value}=e.target;
		 setData({...data,[name]:value});
		 const Errors = await validate({ [name]: value }, fields);
	     setError({...error,[name]:Errors[name]});
		 
	 };
	 
   /** 
   * To handle the form submit event 
   * @e - we get the event details from the form submit action
   **/	
	 const handleSubmit=async(e)=>{
		 e.preventDefault();
		 data.gender=(data.gender || data.gender===0 || data.gender===1 ) ? data.gender:'';
		 data.mobileNumber=data.mobileNumber||'';
		 data.city=data.city||'';
		 data.state=data.state||'';
		 data.zipcode=data.zipcode|| null ;
	     const Errors = await validate(data, fields);
	     setError(Errors);
	     if(!Object.keys(Errors).length && valid){
			 data.gender=(data.gender || data.gender===0 || data.gender===1 ) && data.gender!==''  ? data.gender:null;
		    var response=await ApiService.createParent(data);
			if(response.status===200){
				toast.success(response?.data?.message);
				if (cropImge !== undefined) {
				const formData = new FormData();
				const fileConvertData =await dataURItoBlob(cropImge);
				formData.append('file', fileConvertData);
				 await ApiService.uploadNewPhoto(response?.data?.userId,formData);
			} 
			// Set dynamic ID and message for modal
			await setDynamicId(response?.data?.userId);  // Assuming the physician ID is in the response
			await setModalMessage(t('modal.mapPhyAndHosToParent'));
			await setShowModal(true); // Show modal after success 
				  	
			}else{
				toast.error(response?.data?.message||'Something went wrong');
			}
	     }
	 }
	 
  /** 
  * To handle the image change
  * @e - we get the event details from the input file select action
  **/
  const handleFile=async (e)=>{
	  e.preventDefault();
	  const file = e.target.files[0];
	  openCropModal(file);

  }
  
  /** 
  * To open the image crop modal
  * @file - we pass the image details in the base 64 bit format
  **/
  const openCropModal=async(file)=>{
	  console.log('file ',file)
	  if(file){
		 let ext = file.name.split('.').pop();
		 let allowedExtensions = ['jpg', 'jpeg', 'png', 'JPEG'];
		 if (!allowedExtensions.includes(ext)) {
				toast.error(t('error.fileFormat'));
				await SetShow(false);
				 return;
			}
		if (file.size > 100 * 1024 * 1024) {
			toast.error(t('error.fileSize'));
				await SetShow(false);
				 return;
		}
		 const reader = new FileReader();
		 reader.onload = () => { setImage(reader.result) };
		 reader.readAsDataURL(file);
		 await SetShow(true);
	 }else{
		 await SetShow(false);
	 }
  }
  
  /** 
  * To handle event drag
  * @e - we get the event details from the drag over action
  **/
  const handleDrag=(e)=>{
	  e.preventDefault();
  }
  
  /** 
  * To handle event drop
  * @e - we get the event details from the drop over action
  **/
  const handleDrop=(e)=>{
	  e.preventDefault();
	   const { files } = e.dataTransfer;
	   openCropModal(files[0]);
  }
	 
  /** 
  * To check phone number valid or not 
  * @value - we pass the actual phone number
  * @country - we pass the countryCode
  * @e - we get the event details from the onChange action
  * @formattedValue - we pass the country formatted Value
  **/
  const handlePhone= async(value, country: any, e, formattedValue) => {
      const {format, dialCode} = country;
	  setData({...data,[e.target.name]:formattedValue.split("+"+dialCode+" ")[1],countryCode:'+'+dialCode,countryNameCode:country?.countryCode});
      const Errors = await validate({ [e.target.name]: formattedValue }, fields);
      setError({...error,[e.target.name]:Errors[e.target.name]});
	  
      if (!formattedValue || (format?.length === formattedValue?.length && (value.startsWith(dialCode) || dialCode.startsWith(value)))) {
	       setValid(true);
	  }else{
		   setValid(false);
	  }
  }
  
  /** 
  * To change city input 
  * @e - we get the event details form the change action
  **/
  const changeCity=async(e)=>{
         const { value }=e.target;
		 var obj={};
		 if(value.trim().length ===0){
			 obj={city:'',state:''};
		 }else{
		     obj={city:value};
		 }
		 setData((data)=>({...data,...obj}));
		 const Errors = await validate({ city:value }, fields);
	     setError({...error,city:Errors['city']});
  }
  
  /** 
  * To select city input 
  * @e - we get the event details from the Select action
  **/
  const selectCity=async(e)=>{ 
	     var location= await filterGeoLocation(e);
		 await setData((data)=>({...data,...location}));
  }

   // Handle user confirmation actions for navigation 
   const handleYes = () => {
    setShowModal(false);
	navigate(`/admin/edit-parent/${dynamicId}`);
  };
  const handleNo = () => {
    setShowModal(false);
	navigate('/admin/parents');
  };
	 
	return (
	<main id="main" className="main">
	{/*import ImageCroper*/}
	<ImageCroper 
		show={show} 
		handleClose={handleClose}
		image={image}
		cropImge={imageData}
	/>
	{/* Modal for navigation */}
	<NavigationModal
        show={showModal}
        onHide={() => setShowModal(false)}
        message={modalMessage}
        onYes={handleYes}
        onNo={handleNo}
      />
	{/*Page Title Section*/}
	<div className="pagetitle clearfix">
		<div className="float-start">
		  <h1>{t('profile.addParentInfo')}</h1>
			<nav>
				<ol className="breadcrumb">
				  <li className="breadcrumb-item"><Link to='/admin/dashboard'>{t('sidebar.home')}</Link></li>
				  <li className="breadcrumb-item"><Link to='/admin/parents'>{t('sidebar.parents')}</Link></li>
				  <li className="breadcrumb-item active">{t('profile.addParentInfo')}</li>
				</ol>
			</nav>
		</div>
		<div className="float-end mt-2 me-1">
			<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
		</div>
	</div>
	{/*End Page Title Section*/}
	
	{/*Page Content Section*/}
	<section>
	<div className="row">
		{/*ProfileImg*/}
		<div className="col-xxl-4">
			<div className="card profile-img">
				<div className="card-body">
					<div className="upload-box d-none d-lg-block">		
						<div className="box text-center" onDrop = {handleDrop} onDragOver = {handleDrag}>
							<input type="file" onChange={handleFile} name="file-5" id="file-5" className="inputfile inputfile-4"  />
							<label htmlFor="file-5">
							{cropImge?(<img  className="img-fluid d-block mx-auto" src={cropImge} alt="lo" />):(<img  className="img-fluid d-block mx-auto" src="/assets/img/logo-img.png" alt="lo" />)}
								<span>{t('common.editChange')} <br /> ({t('common.dragDrop')})</span>
							</label>
						</div>
					</div>
					<div className="text-center text-tmBlue mt-4">
						<h6>{t('profile.uploadPicture')}</h6>
					</div>
				</div>
			</div>
		</div>
		
		{/*Parent Info*/}
		<div className="col-xxl-8">
			<div className="card form-card profile-info ">
				<div className="card-body pt-4">
					<ul className="nav nav-pills nav-fill mb-4" id="pills-tab" role="tablist">
					  <li className="nav-item" role="presentation">
						<span className="nav-link active"  type="button" >{t('profile.parentInfo')}</span>
					  </li>
					</ul>
					<div className="tab-content" id="pills-tabContent">							
						
						<div className="tab-pane fade active show">
							 {/* Form Section */}
							<form autoComplete="off">
								<div className="row">
									<div className="col-lg-5 col-md-6">
										<div className=" form-group">
											<label>{t('profile.firstName')} </label>
											<input name="first_name" onChange={handleChange} type="text" className="form-control" placeholder={t('profile.firstName')} />
												{error && error.first_name && <span className="required">{error.first_name}</span>}
										</div>
									</div>
									<div className="col-lg-5 col-md-6">
										<div className=" form-group">
											<label>{t('profile.lastName')}</label>
											<input name="last_name" onChange={handleChange} type="text" className="form-control" placeholder={t('profile.lastName')} />
												{error && error.last_name && <span className="required">{error.last_name}</span>}
										</div>
									</div>
									<div className="col-lg-2 col-md-6">
										<div className=" form-group">
											<label>{t('profile.familyMember')}</label>
											<input name="members" maxLength={2} onChange={handleChange} type="text" className="form-control" placeholder="Ex. 2" />
											{error && error.members && <span className="required">{error.members}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.phoneNumber')}</label>
											<PhoneInput 
												  inputProps={{
                                                  name: 'mobileNumber',
												   style: { width: '100%'}
												   }}
												  country={'us'}  
                                                   onChange={handlePhone}
												/>
											{error && error.mobileNumber && <span className="required">{error.mobileNumber}</span>}
											{!valid && !error.mobileNumber && <span className="required">{t('common.validNumber')}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.emailAddress')}</label>
											<input name="email" onChange={handleChange} type="text" className="form-control" placeholder="youremail@mail.com" />
											{error && error.email && <span className="required">{error.email}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.relation')}</label>
											<select name="gender" value={data?.gender?data.gender:''} onChange={handleChange} className="form-select">
											<option value='' disabled>{t('common.relation')}</option>
											<option value="0" >{t('profile.father')}</option>
											<option value="1" >{t('profile.mother')}</option>
											</select>
											{error && error.gender && <span className="required">{error.gender}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.addressOne')}</label>
											<input name="address_one" onChange={handleChange} type="text" className="form-control" placeholder={t('common.addressLine1')} />
											{error && error.address_one && <span className="required">{error.address_one}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.addressTwo')}</label>
											<input name="address_two" onChange={handleChange} type="text" className="form-control" placeholder={t('common.addressLine2')} />
											{error && error.address_two && <span className="required">{error.address_two}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.city')} </label>
											
											<Autocomplete
											value={data?.city?data.city:''}
											className="form-control" 
											placeholder={t('common.city')} 
											onChange={changeCity}
											 onPlaceSelected={selectCity}
											types={['(cities)']}		
											/>
											{error && error.city && <span className="required">{error.city}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.state')} </label>
											<input name="state" readOnly defaultValue={data?.state?data.state:''} onChange={handleChange} type="text" className="form-control" placeholder={t('common.state')} />
											{error && error.state && !data.state && <span className="required">{error.state}</span>}
										</div>
									</div>
									<div className="col-lg-6 col-md-6">
										<div className=" form-group">
											<label>{t('profile.zipCode')} </label>
											<input name="zipcode" onChange={handleChange} type="text" value={data.zipcode ? data.zipcode : ''} className="form-control" placeholder={t('common.zipCode')} />
											{error && error.zipcode && <span className="required">{error.zipcode}</span>}
										</div>
									</div>
								</div>
								{/* Form Submit Section */}
								<div className="row mt-3">								
									<div className="col-lg-12 text-end">
										<button type="button" onClick={handleSubmit} className="btn btn-tmBlue btnNext"><i className="ri-arrow-right-line align-middle"></i> {t('profile.submit')}</button>
									</div>
								</div>
							</form>
							{/* End Form Section */}
						</div>									
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
{/* End Page Content Section */}	
	
</main>
	);
	
};

export default AddParent;